export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14904.8b755c2f.jpg";